import { EShareMethodType } from '@/services/types/referral/referral';

export enum EWishlistEventName {
  WISHLIST_CREATED = 'Wishlist Created',
  WISHLIST_SELECTED = 'Wishlist Selected',
  WISHLIST_DELETED = 'Wishlist Deleted',
  WISHLIST_EDITED = 'Wishlist Edited',
  WISHLIST_SHARED = 'Wishlist Shared',
  WISHLIST_JOINED = 'Wishlist Joined',
  WISHLIST_LEFT = 'Wishlist Left',
}

export enum EWishlistSelectedSource {
  WISHLIST_MAIN = 'wishlist_main',
  WISHLIST_TOAST = 'toast',
}

export interface IWishlistCreatedEvent {
  rentalID?: number | null;
  wishlistName: string;
  wishlistID: number;
  rentalCategory: string;
}

export interface IWishlistSelectedEvent {
  wishlistName: string;
  wishlistID: number | null; // null for recently viewed
  coverPhotoRentalID?: number | null; // id of the rental whose cover photo is currently used for the wishlist
  wishlistItemCount: number;
  wishlistCreatorID: number | null;
  source: EWishlistSelectedSource;
  rentalCategory: string;
}

export interface IWishlistDeletedEvent {
  wishlistName: string;
  wishlistID: number;
  coverPhotoRentalID: number | null;
  wishlistCreatorID: number | null;
  rentalCategory: string;
}

export interface IWishlistEditedEvent {
  wishlistID: number;
  coverPhotoRentalID: number | null;
  wishlistCreatorID: number | null;
  wishlistName: string | null;
  departureDate: number | null;
  returnDate: number | null;
  totalAdults: number | null;
  totalChildren: number | null;
  isPublic: boolean | null;
  rentalCategory: string;
}

export interface IWishlistSharedEvent {
  wishlistName: string;
  wishlistID: number;
  coverPhotoRentalID: number | null;
  wishlistItemList: number[];
  departureDate: number | null;
  returnDate: number | null;
  totalAdults: number | null;
  totalChildren: number | null;
  shareMethod: EShareMethodType;
  rentalCategory: string;
}

export interface IWishlistJoinedEvent {
  wishlistName: string;
  wishlistID: number;
  wishlistCreatorID: number | null;
  rentalCategory: string;
}

export interface IWishlistLeftEvent {
  wishlistName: string;
  wishlistID: number;
  wishlistCreatorID: number | null;
  rentalCategory: string;
}
